<template>
  <div class="tasks-skeleton">
    <div v-for="col in 6" :key="col" class="tasks-skeleton__column">
      <div class="flex items-center gap-2 pb-3">
        <skeleton width="8px" height="8px" rounded="50%"></skeleton>
        <skeleton width="70px" height="12px" rounded="4px"></skeleton>
        <skeleton width="16px" height="12px" rounded="4px"></skeleton>
      </div>
      <div class="border-t border-black/6 pt-3 flex flex-col gap-2">
        <div v-for="card in getCardCount(col)" :key="card" class="bg-white border border-black/6 rounded-[16px] p-3 shadow-[0_2px_12px_rgba(0,0,0,0.04)]">
          <skeleton width="80px" height="10px" rounded="4px" class-name="mb-2"></skeleton>
          <skeleton width="100%" height="13px" rounded="4px" class-name="mb-1"></skeleton>
          <skeleton width="60%" height="13px" rounded="4px" class-name="mb-2.5"></skeleton>
          <div class="flex items-center justify-between">
            <div class="flex -space-x-1">
              <skeleton v-for="a in (card % 2 === 0 ? 2 : 1)" :key="a" width="22px" height="22px" rounded="50%"></skeleton>
            </div>
            <skeleton width="55px" height="11px" rounded="4px"></skeleton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Skeleton from './Skeleton'

export default {
  name: 'SkeletonTasks',
  components: { Skeleton },
  methods: {
    getCardCount (col) {
      return [3, 2, 4, 2, 1, 2][col - 1]
    }
  }
}
</script>

<style scoped>
.tasks-skeleton {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 12px;
  min-height: calc(100vh - 140px);
}

@media (max-width: 768px) {
  .tasks-skeleton {
    grid-template-columns: repeat(6, minmax(200px, 1fr));
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 12px;
  }
}
</style>
